import { observer } from 'mobx-react-lite';

import { trackerUrls } from '@/tracker/config/urls';
import { sprintHint } from '@/tracker/entities/sprint';
import { Task } from '@/tracker/types';
import { getId, getName } from '@/tracker/utils/optionGetters';

import { CardField } from '../CardField';
import { ChipsField } from '../ChipsField';
import { IssueCardStore } from '../../model/IssueCardStore';

type Props = {
  issue: Task;
  store: IssueCardStore;
};

/** Доски и спринты задачи: плашки со ссылками, добавление поиском и удаление */
const IssueBoardsFields: React.FC<Props> = observer(({ issue, store }) => {
  const isLocked = store.isSaving || store.isReadOnly;

  return (
    <>
      <CardField label="Доски">
        <ChipsField
          chips={issue.boards.map((board) => ({
            id: board.id,
            label: board.name,
            to: trackerUrls.board(board.id),
            removeLabel: `Убрать с доски ${board.name}`,
          }))}
          disabled={isLocked}
          addText="Добавить на доску"
          onRemove={store.removeFromBoard}
          picker={{
            search: store.searchBoards,
            getId,
            getLabel: getName,
            placeholder: 'Название доски',
            ariaLabel: 'Доска',
            noOptionsText: 'Досок не нашлось',
            onSelect: (board) => store.addToBoard(board.id),
          }}
        />
      </CardField>
      {/* На каждой доске у задачи не больше одного спринта, досок может быть несколько */}
      <CardField label="Спринты">
        <ChipsField
          chips={issue.sprints.map((sprint) => ({
            id: sprint.id,
            label: sprint.name,
            hint: sprintHint(sprint),
            to: trackerUrls.boardBacklog(sprint.board.id),
            // Названия спринтов на разных досках совпадают («Спринт 1») — доска в подписи
            removeLabel: `Убрать из спринта ${sprint.name} доски ${sprint.board.name}`,
          }))}
          disabled={isLocked}
          addText="Добавить в спринт"
          onRemove={(id) => {
            const sprint = issue.sprints.find((item) => item.id === id);

            if (sprint) store.removeFromSprint(sprint);
          }}
          picker={{
            search: store.searchSprints,
            getId,
            getLabel: getName,
            getHint: sprintHint,
            placeholder: 'Название спринта',
            ariaLabel: 'Спринт',
            noOptionsText: 'Открытых спринтов нет',
            onSelect: store.addToSprint,
          }}
        />
      </CardField>
    </>
  );
});

export { IssueBoardsFields };
